import { render, staticRenderFns } from "./FormRatingField.vue?vue&type=template&id=6b2f6d8b&"
import script from "./FormRatingField.vue?vue&type=script&lang=js&"
export * from "./FormRatingField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports